import lozad from "lozad";
import "slick-carousel";
import "@fancyapps/fancybox";
import AOS from "aos";

export default {
  init() {
    // JavaScript to be fired on all pages

    // eslint-disable-next-line no-undef
    var ajax_url = global_vars.ajax_url;
    // eslint-disable-next-line no-undef
    var ICL_LANGUAGE_CODE = global_vars.ICL_LANGUAGE_CODE;

    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
    observer.observe();

    $(".direct-list li").on("click", function () {
      $(this).toggleClass("active");
      $(".direct-list li").css({ height: "auto" });
      var listHeight = $(this).height();
      $(".director-pop-up").hide();
      $(this).find(".director-pop-up").show();
      var popupHeight = $(this).find(".director-pop-up").outerHeight();
      var bothHeight = popupHeight + listHeight;
      $(this).css({ height: bothHeight + 30 });
    });

    AOS.init();

    window.addEventListener("load", AOS.refresh);

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $("header").outerHeight();

    $(window).scroll(function () {
      didScroll = true;
    });

    setInterval(function () {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 250);

    function hasScrolled() {
      var st = $(this).scrollTop();

      // Make sure they scroll more than delta
      if (Math.abs(lastScrollTop - st) <= delta) return;

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > navbarHeight) {
        // Scroll Down
        $("header").removeClass("nav-down").addClass("nav-up");
      } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
          $("header").removeClass("nav-up").addClass("nav-down");
        }
      }

      lastScrollTop = st;
    }

    $(window).scroll(function () {
      var sc = $(window).scrollTop();
      if (sc > 200) {
        $("header").addClass("fixed");
      } else {
        $("header").removeClass("fixed");
      }
    });

    $(".product-listing li").on("click", function () {
      $("body").toggleClass("open-modal");
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
      } else {
        $(".product-listing li").removeClass("active");
        $(this).addClass("active");
      }
    });

    // if($(window).width() < 768){

    //   $('.product-listing li').on('click',function(){
    //     var popupheight = $(this).find('.product-pop-up').height() + 190;
    //     if($(this).hasClass('active')){

    //       $(this).css('height', popupheight);

    //     }else{

    //       $(this).css('height', 'initial');

    //     }
    //   });
    // }

    $(".testimonial-box ul").slick({
      dots: false,
      infinite: false,
      speed: 500,
      fade: true,
      cssEase: "linear",
    });

    $(".dish-slider").slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrow: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

    $(".scale-Slider").slick({
      dots: false,
      infinite: true,
      touchThreshold: 100,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      arrows: false,
      // autoplay: true,             // Enable autoplay
      // autoplaySpeed: 2000,
      // variableWidth: true,         // Enable this to allow slides to take their own width
      // centerPadding: '20%',

      // nextArrow: '<button class="slick-next"><i class="fas fa-chevron-right"></i></button>',
      // prevArrow: '<button class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    // $('.scale-Slider .Slider-Content a').on('click', function () {
    //   var slickStatus = $('.scale-Slider').slick('slickGetOption', 'autoplay');
    //   if (slickStatus) {
    //     $('.scale-Slider').slick('slickPause');
    //   }
    //   else {
    //     $('.scale-Slider').slick('slickPlay');
    //   }
    // });

    $(".CSR-Slider").slick({
      speed: 3500,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: "ease-in-out",
      slidesToShow: 3,
      // slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      // initialSlide: 1,
      arrows: false,
      buttons: false,
      pauseOnHover: true,
      pauseOnFocus: false,
      loop: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    }),
      $(".videos-section ul").slick({
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 500,
      });

    if ($("#jobs-department").length > 0) {
      $("#jobs-department").on("change", function () {
        var vl = $(this).val();
        $("#jobs-title option").hide();
        $("#jobs-title")
          .find('[data-term_id="' + vl + '"]')
          .show();
      });
    }

    $(".close-search-box").on("click", function () {
      $(".search-result-box").removeClass("open");
      $("body").removeClass("open-popup");
      $("#global-search").removeClass("open-popup");
    });

    $("#toggle-menu").on("click", function () {
      $(".main-menu").toggleClass("open");
      $("body, html").toggleClass("open-popup");
      $(this).toggleClass("active");
    });

    if ($(window).width() < 769) {
      $(".menu-main-menu-container ul > li.menu-item-has-children > a").each(
        function () {
          $(this).removeAttr("href");
        }
      );
    } else {
      // change functionality for larger screens
    }

    if ($(window).width() < 769) {
      $(".menu-main-menu-container ul li.menu-item-has-children").on(
        "click",
        function () {
          $(this).find(".sub-menu").fadeToggle();
        }
      );
    } else {
      // change functionality for larger screens
    }

    $(".pop-up-trigger").on("click", function () {
      var parent = $(this).parent();
      $(parent).find(".leadership-popup").addClass("open-popup");
      $("body, html").addClass("open-popup");
    });

    $(".close-popup").on("click", function () {
      $(".leadership-popup").removeClass("open-popup");
      $("body, html").removeClass("open-popup");
    });

    if ($(".template-contact-us-new").length > 0) {
      $("#contact_us").on("submit", function (e) {
        e.preventDefault();
        $("#success_message").hide();
        $("#error_message").hide();
        // Check if reCAPTCHA is checked
        // if (grecaptcha.getResponse() == '') {
        //   alert('Please check the reCAPTCHA to proceed.');
        //   return; // Stop form submission
        // }
        var form = $(this);

        form
          .find('button[type="submit"]')
          .text("Submitting...")
          .prop("disabled", true);
        // $('.default-btn').addClass('loading');
        var formData = new FormData($(this)[0]);

        formData.append("action", "contactFormCallback");
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4) {
            if (this.status == 200) {
              var data = JSON.parse(this.responseText);
              grecaptcha.reset();
              if (data.status) {
                $("#success_message").show().html(data.message);
                $("#contact_us")[0].reset();
              } else {
                $("#error_message").show().html(data.message);
              }
            } else {
              // Handle server error or request failure
              $("#error_message")
                .show()
                .html("Error: Server responded with status " + this.status);
            }
            // Reset submit button after processing
            form
              .find('button[type="submit"]')
              .text("Submit")
              .prop("disabled", false);
          }
        };

        xhttp.onerror = function () {
          // Handle AJAX request errors
          $("#error_message")
            .show()
            .html("Error: There was a problem with the request.");
          form
            .find('button[type="submit"]')
            .text("Submit")
            .prop("disabled", false);
        };
        xhttp.open("POST", ajax_url, true);
        xhttp.send(formData);
      });
    }

    if ($(".template-become-a-distributor-data").length > 0) {
      $(".add-more-link").on("click", function () {
        var parentRow = $(this).parent().parent().parent();
        var clone = $(parentRow).clone();
        $(parentRow).after(clone);
        var btn = $(parentRow).next().find(".add-more-link");
        $(btn).remove();
      });

      $("#be-our-distrubutor").on("submit", function (e) {
        e.preventDefault();
        $("#success_message").hide();
        $("#error_message").hide();
        // $('.default-btn').addClass('loading');
        var formData = new FormData($(this)[0]);
        formData.append("action", "distributorFormCallback");
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            var data = JSON.parse(this.responseText);
            // eslint-disable-next-line no-undef
            grecaptcha.reset();
            if (data.status) {
              $("#success_message").show();
              $("#success_message").html(data.message);
              $("#be-our-distrubutor")[0].reset();
            } else {
              $("#error_message").show();
              $("#error_message").html(data.message);
            }
            // $('.default-btn').removeClass('loading');
          }
        };
        xhttp.open("POST", ajax_url, true);
        xhttp.send(formData);
      });
    }

    if ($(".template-media").length > 0) {
      var formData = new FormData();
      formData.append("action", "mediaPressReleaseCallback");
      var xhttp = new XMLHttpRequest();
      xhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          $("#press-release").html(this.responseText);
        }
      };
      xhttp.open("POST", ajax_url, true);
      xhttp.send(formData);

      $("#news-years,#news-months").on("change", function () {
        var news_years = $("#news-years").find(":selected").val();
        var news_months = $("#news-months").find(":selected").val();
        $("#press-release li").hide();

        if (news_years.length > 0 && news_months.length > 0) {
          $(
            '[data-years="' +
              news_years +
              '"][data-months="' +
              news_months +
              '"]'
          ).show();
        } else if (news_years.length == 0 && news_months.length == 0) {
          $("#press-release li").show();
        } else {
          if (news_years.length > 0) {
            $('[data-years="' + news_years + '"]').show();
          }

          if (news_months.length > 0) {
            $('[data-months="' + news_months + '"]').show();
          }
        }
        if ($("#press-release li").is(":visible")) {
          $("#noresultsfound").hide();
        } else {
          $("#noresultsfound").show();
        }
      });

      $(".tabs-list ul li").on("click", function () {
        $(".tabs-list ul li").removeClass("active");
        $(this).addClass("active");
        $(".media-card-section .press-releases").hide();
        $(".media-card-section .commercials-campaigns").hide();
        var dataName = $(this).data("name");
        $("." + dataName).show();
      });

      $("#campaign_videos li").on("click", function () {
        var video_url = $(this).data("video_url");
        var Title = $(this).find(".text-box p").html();
        $($("#video_container").find("iframe")[0]).attr("src", video_url);
        $("#video_container").find(".text-box p").html(Title);
      });
    }

    if ($(".template-our-hiring-process").length > 0) {
      // Cache selectors
      var lastId,
        topMenu = $(".top-menu"),
        topMenuHeight = topMenu.outerHeight() + 15,
        // All list items
        menuItems = topMenu.find("a"),
        // Anchors corresponding to menu items
        scrollItems = menuItems.map(function () {
          var item = $(this).attr("href");
          //var item = $(href);
          if (item.length > 0) {
            return item;
          }
        });
      // Bind click handler to menu items
      // so we can get a fancy scroll animation
      menuItems.on("click", function (e) {
        var href = $(this).attr("href"),
          offsetTop =
            href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
        $("html, body").stop().animate(
          {
            scrollTop: offsetTop,
          },
          300
        );
        e.preventDefault();
      });

      $(window).on("scroll", function () {
        // Get container scroll position
        var fromTop = $(this).scrollTop() + topMenuHeight;
        // Get id of current scroll item
        var cur = scrollItems.map(function () {
          var offset = $(this).offset();
          if (typeof offset !== "undefined" && $(this).offset().top < fromTop) {
            return $(this);
          }
        });

        // Get the id of the current element
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : "";
        if (lastId !== id) {
          lastId = id;
          // Set/remove active class
          menuItems
            .parent()
            .removeClass("active")
            .end()
            .filter('[href="#' + id + '"]')
            .parent()
            .addClass("active");
        }
      });

      $(".sidebar-list li a").on("click", function () {
        var NewFirstLi = $(this).parent().children("ul").children("li");
        var dataName = "";
        var sidebarlist = $(this).parent().closest(".sidebar-list");
        if ($(this).parent().hasClass("top")) {
          dataName = $(this).parent().data("name");
          $(".OurHiringMainsection").hide();
          $(sidebarlist).find("li").removeClass("active");
          $("html, body").stop().animate(
            {
              scrollTop: 0,
            },
            300
          );
        }

        $(this).parent().addClass("active");
        $("." + dataName).show();
        topMenu = $(this).parent();
        topMenu = $(topMenu).children("ul");
        topMenuHeight = topMenu.outerHeight() + 15;
        menuItems = topMenu.find("a");
        // Anchors corresponding to menu items
        scrollItems = menuItems.map(function () {
          var item = $(this).attr("href");
          //var item = $(href);
          if (item.length > 0) {
            return item;
          }
        });

        menuItems.on("click", function (e) {
          var href = $(this).attr("href"),
            offsetTop =
              href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
          $("html, body").stop().animate(
            {
              scrollTop: offsetTop,
            },
            300
          );
          e.preventDefault();
        });

        setTimeout(function () {
          $(NewFirstLi).first().addClass("active");
        }, 500);
      });
    }

    $("#search-field-dsk").on("input", function () {
      var key = $(this).val();
      if (key.length >= 3) {
        var salt = $("#salt-key").val();
        var be_our_distributor = $("#search_key").val();
        $(".search-result-box").addClass("open");
        $("body").addClass("open-popup");
        $("#global-search").addClass("open-popup");
        $(".search-result-box").addClass("loading");
        $(".search-result-box #loader").css("display", "block");
        $.ajax({
          type: "POST",
          global: false,
          dataType: "html",
          url: ajax_url,
          data:
            "action=searchCallback&search_key=" +
            be_our_distributor +
            "&salt=" +
            salt +
            "&key=" +
            key +
            "&current_lang=" +
            ICL_LANGUAGE_CODE,
          success: function (data) {
            var Responsedata = JSON.parse(data);
            if (Responsedata.status == 1 || Responsedata.status == "1") {
              $(".search-result-box").removeClass("loading");
              $("#total_count").html(Responsedata.total_count);
              $("#search-right-widget").html(Responsedata.RightSidePostsHtml);
              $("#MainPosts").html(Responsedata.MainPostsHtml);
              $(".search-result-box #loader").css("display", "none");
            }
          },
        });
      }
    });

    if ($(window).width() < 768) {
      $("#search-field-dsk2").on("input", function () {
        var key = $(this).val();
        if (key.length >= 3) {
          var salt2 = $("#salt-key2").val();
          var be_our_distributor = $("#mobile_search_key").val();
          $(".search-result-box").addClass("open");
          $("body").addClass("open-popup");
          $("#global-search").addClass("open-popup");
          $(".search-result-box").addClass("loading");
          $(".search-result-box #loader").css("display", "block");
          $.ajax({
            type: "POST",
            global: false,
            dataType: "html",
            url: ajax_url,
            data:
              "action=searchCallback&search_key=" +
              be_our_distributor +
              "&salt=" +
              salt2 +
              "&key=" +
              key +
              "&current_lang=" +
              ICL_LANGUAGE_CODE,
            success: function (data) {
              var Responsedata = JSON.parse(data);
              if (Responsedata.status == 1 || Responsedata.status == "1") {
                $(".search-result-box").removeClass("loading");
                $("#total_count").html(Responsedata.total_count);
                $("#search-right-widget").html(Responsedata.RightSidePostsHtml);
                $("#MainPosts").html(Responsedata.MainPostsHtml);
                $(".search-result-box #loader").css("display", "none");
              }
            },
          });
        }
      });
    }

    if ($(".template-investor-relation").length > 0) {
      $(".sidebar-list li").on("click", function () {
        var DataName = $(this).data("name");

        if ($("." + DataName).length > 0) {
          $(".sidebar-list li").removeClass("active");
          $(this).addClass("active");
          $("#AboutCompany").hide();
          $("#FinancialReport").hide();
          $("#KeyHighlights").hide();
          $("#InvestorContacts").hide();
          $("#Notices").hide();
          $("#election-directors").hide();
          $("#gender-pay").hide();
          $("#briefing1").hide();
          $("#briefing").hide();
          $("#free-float").hide();
          $("#" + DataName).show();
        }
      });

      $(".sidebar-list li").on("click", function () {
        var DataName = $(this).data("name");

        if ($("." + DataName).length > 0) {
          $(".sidebar-list li ul li").removeClass("active");
          $("#briefing1").hide();
          $("#briefing").hide();
          $("#" + DataName).show();
        }
      });

      $(".financial-year li").on("click", function () {
        $(".financial-year li").removeClass("active");
        var DataYear = $(this).data("name");
        $(".financial-list").hide();
        $("#report-" + DataYear).show();
        $(this).addClass("active");
      });
    }

    if ($(".template-governance").length > 0) {
      $(".sidebar-list li").on("click", function () {
        var DataName = $(this).data("name");

        if ($("." + DataName).length > 0) {
          $(".sidebar-list li").removeClass("active");
          $(this).addClass("active");
          $("#Profiles").hide();
          $("#ShareholderPattern").hide();
          $("#auditorSection").hide();
          $("#LegalAdvisor").hide();
          $("#ElectionSection").hide();
          $("#" + DataName).show();
        }
      });
    }

    $("#national_videos li").on("click", function () {
      var video_url = $(this).data("src");
      $("iframe").attr("src", video_url);
    });

    $(".cancel_icon").hide();
    $(document).on("input", ".provide-input", function () {
      if ($(this).val().trim().length === 0) {
        $(".cancel_icon").hide();
        $(".search_icon").show();
      } else {
        $(".search_icon").hide();
        $(".cancel_icon").show();
      }
    });

    if ($("#social-media-feeds").length > 0) {
      $(window).on("load", function () {
        $("#social-media-feeds").css("visibility", "visible");
      });
    }

    $(".director-card").on("click", function () {
      setTimeout(() => {
        $(window).scrollTop($(this).next().offset().top - 100);
      }, 100);
    });

    $(".product-img").on("click", function () {
      setTimeout(() => {
        $(window).scrollTop($(this).next().offset().top - 100);
      }, 100);
    });

    if ($(".slider-loading").length > 0) {
      $(window).on("load", function () {
        var formData = new FormData();
        formData.append("action", "homeSlidesCallback");
        formData.append("lang", ICL_LANGUAGE_CODE);
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            $(".home_video_wrapper").find(".loading").hide();
            $(".home_video_wrapper").removeClass("slider-loading");
            $(".home_video_wrapper").html(this.responseText);
            $(".home_video_wrapper .video_item").slick({
              dots: false,
              infinite: true,
              autoplay: true,
              // autoplaySpeed: 5000,
              fade: true,
              cssEase: "linear",
            });
          }
        };
        xhttp.open("POST", ajax_url, true);
        xhttp.send(formData);
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js